import { Tabs } from "antd";
import PurchaseOrderEntry from "./Purchase Order Entry/PurchaseOrderEntry";
import PurchaseOrderRecord from "./PurchaseOrderRecord";
import PurchaseOrderVoucher from "./PurchaseOrderVoucher";
import { useLocation } from "react-router-dom";
import { accessChecker } from "../../../lib/functions";


const PurchaseOrder = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Purchase Order Entry",
      key: "entry",
      value: "purchase_order_entry",
      children: (
        <>
          <PurchaseOrderEntry />
        </>
      ),
    },
    {
      label: "Purchase Order Record",
      key: "record",
      value: "purchase_order_record",
      children: (
        <>
          <PurchaseOrderRecord />
        </>
      ),
    },
    {
      label: "Purchase Order Voucher",
      key: "voucher",
      value: "purchase_order_voucher",
      children: (
        <>
          <PurchaseOrderVoucher />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default PurchaseOrder;
